import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${query.trim()}`);
      setQuery('');
    }
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">Constellation</Link>
      </div>
      <nav>
        <ul>
          <li><Link to="/">首页</Link></li>
          <li><Link to="/match">星座配对</Link></li>
          <li><Link to="/divination">星座占卜</Link></li>
          <li><Link to="/horoscope">星座运势</Link></li>
        </ul>
      </nav>
      <form onSubmit={handleSearch} className="search-form">
        <input 
          type="text" 
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="搜索星座..."
          className="search-input"
        />
        <button type="submit" className="search-button">搜索</button>
      </form>
    </header>
  );
};

export default Header;
